import ClientSelect from './client-select/client-select';
import FacilityReportingGrid from './facility-reporting-grid/facility-reporting-grid';

/***
 * A page or displaying a macro-grid of entered stats data. First, the user selects a client or a list of clients.
 * Then, a macro-grid is generated for every facility belonging to the selected clients for every month in the
 * given year (defaults to the current year).
 *
 * For dates where stats data has been committed, a Jasper report can be generated and viewed.
 */
const facilityReporting = angular
    .module('FacilityData.FacilityReporting', [
        ClientSelect,
        FacilityReportingGrid
    ])
    .config(($stateProvider) => {
        'ngInject';
        $stateProvider.state('app.facility-reporting', {
                abstract: true,
                resolve: {
                    userAuth: (
                        $state,
                        updateUser,
                        CurrentUser
                    ) => {
                        if (!CurrentUser.isFacilityAdmin()) {
                            $state.go('app.home', {}, {reload: true});
                        }
                    }
                },
            });
    })
    .name;

export default facilityReporting;


// WEBPACK FOOTER //
// ./app/components/facility-reporting/facility-reporting.js